import React from 'react';
import { TextField } from '@mui/material';

const RichTextEditor = ({ value, onChange, placeholder, ...props }) => {
  return (
    <TextField
      multiline
      rows={4}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      variant="outlined"
      fullWidth
      {...props}
    />
  );
};

export default RichTextEditor;